"use client"

import React, { useEffect } from "react"
import { APP_URLS } from "config/urls"
import { navigateTo } from "utils/navigateTo"
import { dispatch } from "@shared/utils.events"
import { WishlistIcon, ProfileIcon } from "components/SVG"
import {
  navStickyFooterWrapper,
  navStickyFooter,
  navStickyFooterLink,
  verticalSeparator,
  stickyNavItem,
  stickyNavItemSpan,
} from "./NavStickyFooter.css"
import { NotificationDot } from "../../../../../packages/membership/components/NotificationDot"
import { useRouter } from "../../../../../lib/router"
import { useUser } from "../../../../../lib/user"

type Props = {
  showNotification?: boolean
}

export const NavStickyFooter: React.FC<Props> = ({ showNotification }) => {
  const { memberBenefits, wishlist } = APP_URLS
  const [notificationClicked, setNotificationClicked] =
    React.useState<boolean>(false)
  const router = useRouter()

  const isOrderItAgainPage = router.pathname.includes(
    "/account/favourites/order-it-again"
  )

  const { isMember } = useUser()

  useEffect(() => {
    setNotificationClicked(!!localStorage.getItem("HIGHLIGHTED_NAV_ITEM"))
  }, [])

  return (
    <div className={navStickyFooterWrapper}>
      <div className={navStickyFooter}>
        <div className={navStickyFooterLink}>
          <button
            type="button"
            className={stickyNavItem}
            onClick={() => {
              dispatch("page element clicked", {
                target: "Member Benefits",
                details: "Mobile Navigation",
                location: "Sticky Footer",
              })
              if (showNotification) {
                const element = document.querySelector(".mobile-nav-extra-item")
                element && element.scrollIntoView({ behavior: "smooth" })
              } else {
                navigateTo(memberBenefits)
              }
            }}
          >
            <ProfileIcon />
            <span className={stickyNavItemSpan}>My Account</span>
            {showNotification &&
              !notificationClicked &&
              !isOrderItAgainPage &&
              isMember && <NotificationDot />}
          </button>
        </div>
        <div className={verticalSeparator} />
        <div className={navStickyFooterLink}>
          <button
            type="button"
            className={stickyNavItem}
            onClick={() => {
              dispatch("page element clicked", {
                target: "My Wishlist",
                details: "Mobile Navigation",
                location: "Sticky Footer",
              })
              navigateTo(wishlist)
            }}
          >
            <WishlistIcon />
            <span className={stickyNavItemSpan}>My Wishlist</span>
          </button>
        </div>
      </div>
    </div>
  )
}
